import { useContext } from 'react';
// eslint-disable-next-line import/no-cycle
import { Context as PaymentMethodsContext } from '@context/PaymentMethodsContext';

const usePaymentMethods = () => {
  const paymentMethodsContext = useContext(PaymentMethodsContext);
  return {
    state: paymentMethodsContext
  };
};

export default usePaymentMethods;
